import axios from 'axios';

const API_BASE = 'https://api.nuance.radio';

const api = axios.create({
  baseURL: API_BASE,
});

export default api; 